import { render, staticRenderFns } from "./ClampedText.vue?vue&type=template&id=70b63a08&scoped=true&"
import script from "./ClampedText.vue?vue&type=script&lang=js&"
export * from "./ClampedText.vue?vue&type=script&lang=js&"
import style0 from "./ClampedText.vue?vue&type=style&index=0&id=70b63a08&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b63a08",
  null
  
)

export default component.exports